import ComponentType from '../enums/componentType';
import ComponentState from '../enums/componentState';
import maintenaceStatus from '../enums/maintenaceStatus';

import websiteLogo from '../image/components/website.png';
import skypeLogo from '../image/components/skype.png';
import emailLogo from '../image/components/email.png';
import sharepointLogo from '../image/components/sharepoint.png';
import mapValues from 'lodash/mapValues';
import invert from 'lodash/invert';

const statusById = invert(mapValues(maintenaceStatus, type => type.id));

export function getComponentIcon(type) {
    switch (type) {
        case ComponentType.general:
            return websiteLogo;
        case ComponentType.skype:
            return skypeLogo;
        case ComponentType.exchange:
            return emailLogo;
        case ComponentType.sharePoint:
            return sharepointLogo;
        default:
            return null;
    } 
}

export function getComponentStateInfo(state) {
    switch (state) {
        case ComponentState.operational:
            return { color:"#3fc787", description: "Operational"};
        case ComponentState.partialOutage:
            return { color:"#e67e22", description: "Partial Outage"};
        case ComponentState.degradedPerformance:
            return { color:"#f1c40f", description: "Degraded Performance"};
        case ComponentState.majorOutage:
            return { color:"#ff817d", description: "Major Outage"};
        case ComponentState.underMaintenance:
            return { color:"#65bdf6", description: "Under Maintenance"};
        default:
            return { color:"black", description: ""};
    } 
}

export function getMaintenanceSatusInfo(id) {
    const status = statusById[id];
    if (status) {
        return maintenaceStatus[status];
    }
}
